<template>
    <ForgotPassword/>
</template>

<script>
    export default {
        name: "forgot-password",
        components: {
            'ForgotPassword': () => import("../components/ForgotPassword")
        },
    }
</script>

<style scoped>

</style>